import React, { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { HomeRepresentantes } from '../../screens/Representante/HomeRepresentantes'
import { NavDocumentosRep } from '../../screens/Representante/FirmaDigital/NavDocumentosRep'
import { SideBarRepresentantes } from '../../components/Representantes/SideBarRepresentantes'
import { NavBarRepresentantes } from '../../components/Representantes/NavBarRepresentantes'
import { FirmarPdfRep } from '../../screens/Representante/FirmaDigital/FirmarPdfRep'
import {  useSelector } from 'react-redux'
import Swal from 'sweetalert2'


export const NavigationLogRepresentantes = () => {


  const empresa  = useSelector(state => state.app.empresa)

  

  const alert = () => {

    if(empresa.value) return

      Swal.fire({
        title: 'Selecciona una empresa',
        text:'Para continuar, selecciona una empresa en el menu lateral de la izquierda.',
        confirmButtonColor:'#2ec1db',
      
      })

  }

    useEffect(() => {
    
      alert()

    }, [empresa])

    useEffect(() => {
    
      alert()

    }, [])
    

  return (
    
    <>
    
    
    <div className='contenedor' >

      {
        window.innerWidth >= 771  ? <SideBarRepresentantes/> : <NavBarRepresentantes/>
      }

      

      <div className="contenedorContenido">

      <Routes>

     



              {/* <Route path='/home-representantes' element={<HomeRepresentantes />} /> */}
              <Route path='/firma-representantes' element={<NavDocumentosRep />} />
              <Route path='/firmar-pdf-representantes/:id' element={<FirmarPdfRep />} />
             
              

              <Route
              path="*"
              element={<Navigate to="/firma-representantes" replace />}
              />



        </Routes>


      </div>

  


    </div>

    
    
    

    
    </>
    
    
   
  )
}
